import { BaseQueryFn, EndpointBuilder, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { ResponseOrderDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<ResponseOrderDto & { endUserFullName: string }, string>({
        async queryFn(orderId, _queryApi, _extraOptions, fetchWithBQ) {
            const orderResult = await fetchWithBQ(`${APP_ENDPOINTS.ORDER}/${orderId}`);
            if (orderResult.error) return { error: orderResult.error as FetchBaseQueryError };

            const order = orderResult.data as ResponseOrderDto;

            let endUserFullName = '';
            if (order.endUser) {
                endUserFullName = order.endUser.fullName;
            } else if (order.guestUser) {
                endUserFullName = order.guestUser.fullName;
            }

            return {
                data: {
                    ...order,
                    endUserFullName,
                },
            };
        },
        providesTags: [{ type: 'order', id: 'GET-ID' }],
    });
